<template>
  <mask-side-section-container :title="sectionTitle">
    <v-flex shrink style="height: 100%; overflow: auto" class="scroll-fire-fox">
      <div style="margin: 4px 20px">
        To stop the current duct entry action, click on the selected duct entry
        to deselect it or selected another duct entry
      </div>
    </v-flex>
  </mask-side-section-container>
</template>

<script>
import MaskSideSectionContainer from "../Masks/MaskSideSectionContainer";
export default {
  name: "DuctEntryAction",
  components: { MaskSideSectionContainer },
  computed: {
    mode() {
      return this.$store.getters.getMaskDuctEntryMode;
    },

    sectionTitle() {
      if (this.mode === "move") {
        return this.$i18n.t("Move");
      } else if (this.mode === "clone") {
        return this.$i18n.t("Clone");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryAction.vue